import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import useAppStore from "../../store/global";
import { Spinner } from "react-bootstrap";
import { getPendingReportIds, syncReport } from "./api";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";

export default function PendingReportModal({ show, onHide, id }) {
  const navigate = useNavigate();
  const { pageSize } = useAppStore();
  const [reports, setReports] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [syncing, setSyncing] = useState(false);
  const [showSales, setShowSales] = useState(false);
  const [showLabour, setShowLabour] = useState(false);

  const fetchReports = () => {
    setLoading(true);
    getPendingReportIds(pageNum, pageSize, id)
      .then((data) => {
        setReports(data.pending_reports.filter((report) => report.raw_output.length > 0) );
        setTotalPages(data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setReports([]);
        setTotalPages(0);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      id === undefined ||
      id === null ||
      id === "" ||
      typeof id === "string"
    ) {
      return;
    }

    setLoading(true);
    getPendingReportIds(pageNum, pageSize, id)
      .then((data) => {
        setReports(data.pending_reports.filter((report) => report.raw_output.length > 0));
        setTotalPages(data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setReports([]);
        setTotalPages(0);
        setLoading(false);
      });
  }, [id, pageNum, pageSize]);

  const syncReports = () => {
    setSyncing(true);
    syncReport(selected)
      .then((data) => {
        setSyncing(false);
        setSelected([]);
        fetchReports();
        toast.success(data.message);
      })
      .catch((err) => {
        setSyncing(false);
        toast.error(err.message);
      });
  };


  return (
    <>
      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Pending Reports
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : reports.length > 0 ? (
            <>
              <table className="table table-bordered text-center table-responsive table-stack">
                <thead>
                  <tr>
                    <th>Report</th>
                    <th>Report Type</th>
                    <th>Report Date</th>
                    <th>
                      <label>Select All</label>
                      <input
                        className="mx-1"
                        type="checkbox"
                        onChange={(e) => {
                          if (e.target.checked) {
                            // select only those reports that have status as verified
                            const filteredReports = reports
                              .filter(
                                (report) =>
                                  report.status === "verified" &&
                                  report.raw_output.length > 0 
                              )
                              .map((report) => report.report_id);
                            setSelected(filteredReports);
                          } else {
                            setSelected([]);
                          }
                        }}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((report, index) => (
                    <tr key={index}>
                      <td data-label="Report">
                        <Link
                        target="_blank"
                        rel="noopener noreferrer"
                          to={`/restaurants/reports/report-details/${report.report_id}`}
                        >
                          <button className="btn btn-sm btn-primary">
                            View Report
                          </button>
                        </Link>
                      </td>
                      <td data-label="Report Type">{report.report_type == "product" ? 'Daily Sales' : 'Daily Labor' }</td>
                      <td data-label="Report Date">{report.report_date}</td>
                      <td data-label="Select">
                        <input
                          type="checkbox"
                          disabled={
                            report.status !== "verified" ||
                            report.raw_output?.length === 0
                          }
                          checked={selected.includes(report.report_id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelected((prev) => [
                                ...prev,
                                report.report_id,
                              ]);
                            } else {
                              setSelected((prev) =>
                                prev.filter((item) => item !== report.report_id)
                              );
                            }
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-end my-2">
                {selected.length > 0 && (
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => {
                      syncReports();
                    }}
                  >
                    {syncing ? (
                      <Spinner animation="border" variant="light" size="sm" />
                    ) : (
                      "Sync"
                    )}
                  </Button>
                )}
              </div>
            </>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <p>No reports available</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </>
  );
}
